import UserbackWidgetLoader from '@userback/widget';

/**
 * Settings for the Feature Request / Bug Report button (TS-1755), the Userback widget. The
 * token is public (the browser receives it, as in Leve). It comes from the environment's
 * `/config.js` (`userbackToken`, written by the release) or, locally, `VITE_USERBACK_TOKEN`;
 * unset, the button does not load.
 */
export function feedbackConfig(
  env: ImportMetaEnv = import.meta.env,
  runtime: CrmRuntimeConfig | undefined = window.__CRM_CONFIG__,
): { token: string; release: string } | null {
  const token = runtime?.userbackToken || env.VITE_USERBACK_TOKEN;
  if (!token) return null;
  return { token, release: runtime?.release || 'dev' };
}

// The widget is a singleton on window.Userback and must load exactly once, even across React
// Strict Mode's dev double mount: module scope survives the remount, component state does not.
let loading: Promise<unknown> | null = null;

/** Loads Userback once, bottom right, with the reporter filled in. A failure is retried later. */
export function loadFeedbackWidget(
  token: string,
  user: { id: string; name: string; email: string },
): Promise<unknown> {
  loading ??= UserbackWidgetLoader(token, {
    name: user.name,
    email: user.email,
    user_data: { id: user.id, info: { name: user.name, email: user.email } },
    widget_settings: { position: 'se' },
  }).catch((err: unknown) => {
    // Non-critical: never break the page over it; the next mount may try again.
    console.warn('feedback widget failed to load', err);
    loading = null;
  });
  return loading;
}

/** Test seam: forget the module-scope load so each test starts from nothing. */
export function resetFeedbackWidgetForTests() {
  loading = null;
}
